export const getCountryInfo = () => {
    return new Promise ((resolve, reject) => {
        resolve(window.countryCode)
    });
};
